if (!customElements.get('community-gallery')) {
  customElements.define(
    'community-gallery',
    class CommunityGallery extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.community-gallery__dialog');
        this.dialogMedia = this.querySelector('.community-gallery__dialog-media');
        if (!this.dialog || !this.dialogMedia) return;

        this.querySelectorAll('.community-gallery__open').forEach((button) => {
          button.addEventListener('click', () => this.open(button));
        });
        this.querySelector('.community-gallery__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.dialogMedia.replaceChildren();
          if (this.lastTrigger) this.lastTrigger.focus();
        });
      }

      open(button) {
        this.lastTrigger = button;
        const image = document.createElement('img');
        image.className = 'community-gallery__dialog-image';
        image.src = button.dataset.fullSrc;
        image.alt = button.dataset.alt || '';
        this.dialogMedia.replaceChildren(image);
        this.dialog.showModal();
      }
    }
  );
}
